import React, { FC, MouseEvent } from 'react';
import classNames from 'classnames';

import { IFilter } from 'types/filters';

import { fc } from 'i18n';

import styles from './styles.module.css';

interface ISelectOptionProps {
  selectedFilter: IFilter | null;
  filter: IFilter;
  onSelect: (option: IFilter) => (event: MouseEvent<HTMLDivElement>) => void;
}

export const FiltersOption: FC<ISelectOptionProps> = ({ selectedFilter, filter, onSelect }) => {
  const optionClassname = classNames(styles.option, {
    [styles.selected]: selectedFilter?.urlKey === filter.urlKey,
  });

  return (
    <div className={optionClassname} onClick={onSelect(filter)}>
      {fc(filter.label)}
    </div>
  );
};
